<div class="order-product-list">
	<div class="products">
		@for (item of itemData$().items; track item.uuid) {
			<div class="product" data-cy="orderProduct">
				<!-- TODO: Refactor using plain CSS Grid properly. -->
				<div
					class="product-grid"
					gdRows="[image-title] 1fr [info] auto [actions] auto"
					gdRows.gt-xs="auto"
					gdColumns="80px 1fr 1fr"
					[gdColumns.gt-xs]="
						buttonVisibilityData$().buttonColumnLayout.get(item.uuid) || '80px 5fr 1fr 1fr'
					"
					gdAlignColumns="start center"
					gdGap="1rem"
				>
					<g-product-image
						[images]="itemData$().productImages.get(item.uuid)!"
						key="fitIn_80x80"
						isZoomable
						[altText]="item.work_title || (item.product?.locale?.product_name | getText)"
						[proofImageDetails]="itemData$().proofImageDetails.get(item.uuid)"
					/>

					<div
						class="product-details"
						gdRow="image-title"
						gdRow.gt-xs="auto"
						gdColumn="2 / span 2"
						gdColumn.gt-xs="2"
					>
						<a class="product-link" [title]="item.work_title">
							{{ item.work_title }}
						</a>
					</div>
					<div class="product-quantity" gdRow="info" gdRow.gt-xs="auto" gdColumn="2" gdColumn.gt-xs="3">
						{{ item | getProductQuantity }}&nbsp;
						<span>{{ item | getQuantityUnit }}</span>
					</div>
					@if (showPrices$()) {
						<div
							class="product-price"
							gdRow="info"
							gdRow.gt-xs="auto"
							gdColumn="3"
							gdColumn.gt-xs="4"
							gdGridAlign="end center"
						>
							{{ item?.price?.price_with_tax | number: '1.2-2' }} €
						</div>
					}

					@if (buttonVisibilityData$().isButtonColumnVisible.get(item.uuid)) {
						<div
							class="product-button"
							gdRow="actions"
							gdRow.gt-xs="auto"
							gdRows="1fr"
							gdGridAlign.gt-xs="end center"
						>
							@if (buttonVisibilityData$().isDownloadButtonVisible.get(item.uuid)) {
								<button
									class="btn btn-small btn-secondary"
									(click)="downloadProductAsset(item)"
									gdColumn="1"
									i18n="@@OrderProductDownloadButton"
									>Download</button
								>
							}
							@if (buttonVisibilityData$().isCopyButtonVisible.get(item.uuid)) {
								<button
									class="btn btn-small btn-primary"
									[disabled]="
										!isExistingProduct(item) ||
										(item.product?.type === 'stock' &&
											!!item.product?.id &&
											stockLevels.get(item.product!.id!) === 0)
									"
									(click)="copyToBasket(item)"
									gdColumn="2"
									data-cy="copyToBasketButton"
									i18n="@@OrderProductCopyToBasketButton"
									>Copy to basket</button
								>
							}
						</div>
					}
				</div>

				@if (
					buttonVisibilityData$().isCopyButtonVisible.get(item.uuid) &&
					isOrderStatusReady &&
					!isExistingProduct(item)
				) {
					<div class="product-notification">
						<span i18n="@@OrderProductListNotificationProductDoesNotExist"
							>Product has been removed from store and cannot be reordered.</span
						>
					</div>
				}
				@if (showPrintfileError(item)) {
					<span class="error" i18n="@@ProductPrintfileExpired"
						>The printfile has expired. Remove this item and re-upload the printfile.</span
					>
				}
				@if (
					buttonVisibilityData$().isCopyButtonVisible.get(item.uuid) &&
					!!item.product?.id &&
					stockLevels.get(item.product!.id!)! > 0 &&
					(item | getProductQuantity) > stockLevels.get(item.product!.id!)!
				) {
					<div class="product-notification">
						<span i18n="@@OrderProductListNotificationNotEnoughStock"
							>Not enough products in stock.</span
						>
					</div>
				}
				@if (
					buttonVisibilityData$().isCopyButtonVisible.get(item.uuid) &&
					item.product &&
					item.product.id &&
					stockLevels.get(item.product.id) === 0
				) {
					<div class="product-notification">
						<span i18n="@@OrderProductListNotificationOutOfStock">Product is out of stock.</span>
					</div>
				}
			</div>
		}
	</div>
</div>
